var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "550px" },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
          return _vm.save.apply(null, arguments)
        },
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", [
            _c("span", { staticClass: "headline" }, [_vm._v("Touch Config")]),
          ]),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "pt-5",
                      attrs: { cols: "12", sm: "6", md: "6" },
                    },
                    [
                      _c("r-item-touch-action", {
                        attrs: {
                          model: _vm.model.longTouchAction,
                          label: "Long Touch Action",
                        },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(
                              _vm.model,
                              "longTouchAction",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "pt-5",
                      attrs: { cols: "12", sm: "6", md: "6" },
                    },
                    [
                      _c("v-checkbox", {
                        attrs: {
                          label: "Long touch reminder",
                          "hide-details": "",
                          disabled:
                            !_vm.model || _vm.model.longTouchAction.id === 0,
                        },
                        model: {
                          value: _vm.model.longTouchReminder,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "longTouchReminder", $$v)
                          },
                          expression: "model.longTouchReminder",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.save },
                },
                [_vm._v("Save")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }